// extracted by mini-css-extract-plugin
module.exports = {"container":"CopyCodeButton_container__ddHIk"};